// ----------------------------------------------------------------------
// <copyright file="Izenda.MapStaticContentFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Static Content Fetcher
 */

import fetch from 'share/fetch/Izenda.Fetch';
import { isArray } from 'lodash/fp';

export default {
  /**
   * Get GEO file based on map name, map name is defined in MapCollectionConstants
   * @param  {string} mapName
   * @return {json}
   */
  getGEOJson(mapName) {
    mapName = mapName || 'world';
    return fetch(['content/maps/', mapName, '.geo.json'].join('')).get();
  },

  /**
   * Get details of cities
   * @param  {array} criterias
   * @param  {array} values
   * @return {array}
   */
  getCities(criterias, values) {
    return fetch('databaseSetup/staticData/city').post({
      Criterias: isArray(criterias) ? criterias : [criterias],
      Values: values
    });
  },

  /**
   * Get details of postal code
   * @param  {array} criterias
   * @param  {array} values
   * @return {array}
   */
  getPostalCode(criterias, values) {
    return fetch('databaseSetup/staticData/postalCode').post({
      Criterias: isArray(criterias) ? criterias : [criterias],
      Values: values
    });
  },

  /**
   * Get list all country
   * @return {array}
   */
  getCountryCode: () => {
    return fetch('databaseSetup/staticData/countryCodes').get();
  }
};



// WEBPACK FOOTER //
// ./ui/fetchers/Izenda.MapStaticContentFetcher.js